import { redirectInterceptor } from '@adjust/dashboard-core/api/instance/redirect-interceptor/redirect-interceptor';

function RedirectInterceptor() {
  'ngInject';
  return {
    response: redirectInterceptor,
  };
}

export { RedirectInterceptor };
